import { render } from "./CounterpartyInfoComponent.vue?vue&type=template&id=ad151972&ts=true"
import script from "./CounterpartyInfoComponent.vue?vue&type=script&lang=ts"
export * from "./CounterpartyInfoComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QBtn,QDialog});
